<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.message.elements.attachments.types.reservation.action.title')"
    :info="customer.displayName"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.attach'), type: 'confirm', callback: handleConfirm, disabled: !valid },
    ]"
    :loading="loading"
    :portal="portal"
  >
    <div class="relative">
      <reservation-select
        v-model="reservation"
        :customer="customer"
      />
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import ReservationSelect from '@/components/reservation/elements/Select.vue'

import { CustomerMessageAttachment, CustomerMessageAttachmentType } from '~/_api/models/customerMessage'

interface Props {
  portal?: string
  loading?: boolean
  customer: Record<string, any>
}

withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<{
  (e: 'confirm', attachments: any[]): void
}>()

const dialog = ref<any>()
const reservation = ref<any>(null)

const valid = computed(() => !!reservation.value)

const open = () => {
  reservation.value = null
  dialog.value.open()
}

const handleConfirm = async () => {
  if (!reservation.value) {
    return false
  }

  const attachment = new CustomerMessageAttachment({
    type: CustomerMessageAttachmentType.reservation,
    id: reservation.value.idReservation,
    data: reservation.value,
  })

  emit('confirm', [attachment])

  return true
}

defineExpose({ open })
</script>
